import SalpHeader from './SalpHeader';

export default SalpHeader;
